<template>
  <div class="Home">
    <Header>
      <template v-slot:default>
        <div class="spaceHeight"></div>
        <div class="row"></div>
      </template>
    </Header>

    <div class="container-fluid ">
      <div class="layout">
        <!-- Tables KOT Bill -->
        <input
          name="nav"
          type="radio"
          class="nav home-radio"
          id="home"
          checked="checked"
        />
        <div class="page home-page">
          <div class="page-contents container-fluid">
            <div class="row">
              <div class="col-lg-12" style="margin-bottom: 15px;">
                <FilterBar
                  :statusOptions="KitchenStatusTypes"
                  statusPlaceholder="Kitchen Status"
                  @StartDate="tablewayStartDate"
                  @EndDate="tablewayEndDate"
                  @FilterQuery="GetKitchenTickets"
                  @Status="GetTableStatus"
                  @searchQuery="SearchTableTicket"
                  @clearFilter="ClearTableFilter"
                />
              </div>
              <div
                class="col-lg-3"
                v-for="(ticket, index) in Tickets"
                :key="index"
              >
                <KOTTICKETPRINTPREVIEW :ticket="ticket" />
              </div>
            </div>
          </div>
        </div>
        <label class="nav" for="home">
          <span>
            Tables
          </span>
        </label>
        <!-- TakeAway KOT Bill  -->
        <input name="nav" type="radio" class="about-radio" id="takeaway" />
        <div class="page about-page">
          <div class="page-contents ">
            <div class="row">
              <div class="col-lg-12" style="margin-bottom: 15px;">
                <FilterBar
                  :statusOptions="KitchenStatusTypes"
                  statusPlaceholder="Kitchen Status"
                  @StartDate="takeawayStartDate"
                  @EndDate="takeawayEndDate"
                  @FilterQuery="GetKitchenTakeawayickets"
                  @Status="GetTakewayStatus"
                  @searchQuery="SearchTakeAwayTicket"
                  @clearFilter="ClearTakeawayFilter"
                />
              </div>
              <div
                class="col-lg-3"
                v-for="(ticket, index) in TicketsTakeAway"
                :key="index"
              >
                <KOTTICKETPRINTPREVIEW :ticket="ticket" />
              </div>
            </div>
          </div>
        </div>
        <label class="nav" for="takeaway">
          <span>
            TakeAway
          </span>
        </label>
        <!-- Room KOT Bill -->
        <input name="nav" type="radio" class="about-radio" id="about" />
        <div class="page about-page">
          <div class="page-contents ">
            <div class="row">
              <div class="col-lg-12" style="margin-bottom: 15px;">
                <FilterBar
                  :statusOptions="KitchenStatusTypes"
                  statusPlaceholder="Kitchen Status"
                  @StartDate="RoomStartDate"
                  @EndDate="RoomEndDate"
                  @FilterQuery="GetKitchenRoomTickets"
                  @Status="GetRoomStatus"
                  @searchQuery="SearchRoomTicket"
                  @clearFilter="ClearRoomFilter"
                />
              </div>
              <div
                class="col-lg-3"
                v-for="(ticket, index) in TicketsRooms"
                :key="index"
              >
                <KOTTICKETPRINTPREVIEW :ticket="ticket" />
              </div>
            </div>
          </div>
        </div>
        <label class="nav" for="about">
          <span>
            Rooms
          </span>
        </label>
      </div>

      <div v-if="!Tickets.length" class="NoItemsMessage w-100">
        No Items
      </div>
    </div>
  </div>
</template>

<script>
import { DatePicker } from '@/components/base/index';
import {
  MenuComponent,
  PlusMinusInput,
  Button as DeleteIcon,
  Swipe,
  CustomModal as CModal,
} from '@/components/base/index.js';
import {
  KOTTICKETPRINTPREVIEW,
  CheckboxList,
  ListingFilter,
  Header,
  RefreshButton,
  FilterBar,
} from '@/components/index.js';

const iconComponent = {
  template: `
        <span class="my-icon">{{ opened ? 'I am open' : ' I am closed' }}</span>
    `,
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
};

import VueRangeSlider from 'vue-range-component';
import _ from 'lodash';
import 'vue-range-component/dist/vue-range-slider.css';
import axios from '@/plugins/axios';
import moment from 'moment';
export default {
  name: 'Home',
  data() {
    const today = moment().format('YYYY-MM-DD');
    return {
      KitchenStatusTypes: [
        { name: "pending", Value: "Pending" },
        { name: "preparing", Value: "Preparing" },
        { name: "finished", Value: "Finished" },
        { name: "cancelled", Value: "Cancelled" },
      ],
      iconComponent: iconComponent,
      selected: { key: '1', text: 'select' },
      completeBill: false,
      selectedMethod: { key: '1', text: 'select' },
      Order: [],
      typesLoaded: false,
      isOrder: false,
      orderId: null,
      NewlyOrdered: [],
      Tickets: [],
      TicketsRooms: [],
      TicketsTakeAway: [],
      TakeawayStartDate: today,
      RoomStartDate: today,
      TableStartDate: today,
      TakeawayEndDate: today,
      RoomEndDate: today,
      TableEndDate: today,
      TakeawayStatus: '',
      RoomStatus: '',
      TableStatus: '',
      TakeawayQuery: '',
      RoomQuery: '',
      Tablequery: '',
      today: new Date(),
    };
  },
  components: {
    KOTTICKETPRINTPREVIEW,

    Header,
    CModal,
    DatePicker,
    FilterBar,
  },
  methods: {
    RefreshData() {
      this.GetKitchenTickets();
      this.GetKitchenRoomTickets();
    },
    //Getting Filter TakeAway Start Date
    takeawayStartDate(event) {
      this.TakeawayStartDate = event;
    },

    //Getting Filter Room Start Date
    RoomStartDate(event1) {
      this.RoomStartDate = event1;
    },

    //Getting Filter Table Start Date
    tablewayStartDate(event2) {
      this.TableStartDate = event2;
    },
    //Getting Filter TakeAway End Date
    takeawayEndDate(event) {
      this.TakeawayEndDate = event;
    },

    //Getting Filter Room End Date
    RoomEndDate(event1) {
      this.RoomEndDate = event1;
    },

    //Getting Filter Table End Date
    tablewayEndDate(event2) {
      this.TableEndDate = event2;
    },
    //Getting Filter Table Status
    GetTableStatus(event2) {
      this.TableStatus = event2 && event2.name ? event2.name : '';
    },
    //Getting Filter Room Status
    GetRoomStatus(event2) {
      this.RoomStatus = event2 && event2.name ? event2.name : '';
    },
    //Getting Filter TakeAway Status
    GetTakewayStatus(event2) {
      this.TakeawayStatus = event2 && event2.name ? event2.name : '';
    },
    //Getting Filter Table searchquery
    SearchTableTicket(event2) {
      this.Tablequery = event2;
    },
    //Getting Filter Takeaway searchquery
    SearchTakeAwayTicket(event2) {
      this.TakeawayQuery = event2;
    },
    //Getting Filter Room searchquery
    SearchRoomTicket(event2) {
      this.RoomQuery = event2;
    },
    //clear All Room Filters And Get All Tickets
    ClearRoomFilter(event) {
      const today = moment().format('YYYY-MM-DD');
      this.RoomStatus = event || '';
      this.RoomQuery = event || '';
      this.RoomStartDate = today;
      this.RoomEndDate = today;
      this.GetKitchenRoomTickets();
    },
    //clear All TakeAway Filters And Get All Tickets
    ClearTakeawayFilter(event) {
      const today = moment().format('YYYY-MM-DD');
      this.TakeawayStatus = event || '';
      this.TakeawayQuery = event || '';
      this.TakeawayStartDate = today;
      this.TakeawayEndDate = today;
      this.GetKitchenTakeawayickets();
    },
    //clear All Table Filters And Get All Tickets
    ClearTableFilter(event) {
      const today = moment().format('YYYY-MM-DD');
      this.TableStatus = event || '';
      this.Tablequery = event || '';
      this.TableStartDate = today;
      this.TableEndDate = today;
      this.GetKitchenTickets();
    },

    //Getting Tables KOT Tickets
    GetKitchenTickets() {
      axios
        .get(
          `hms/web/orders/all?query=${this.Tablequery}&orderType=dine_in&kitchen_status=${this.TableStatus}&start=${this.TableStartDate}&end=${this.TableEndDate}`
        )
        .then((res) => {
          this.Tickets = res.data;

          this.typesLoaded = true;
        })
        .catch((err) => {});
    },
    //Getting Room KOT Tickets
    GetKitchenRoomTickets() {
      axios
        .get(
          `hms/web/orders/all?query=${this.RoomQuery}&orderType=service_order&kitchen_status=${this.RoomStatus}&start=${this.RoomStartDate}&end=${this.RoomEndDate}`
        )
        .then((res) => {
          this.TicketsRooms = res.data;

          this.typesLoaded = true;
        })
        .catch((err) => {});
    },
    //Getting Takeaway KOT Tickets
    GetKitchenTakeawayickets() {
      axios
        .get(
          `hms/web/orders/all?query=${this.TakeawayQuery}&orderType=take_away&kitchen_status=${this.TakeawayStatus}&start=${this.TakeawayStartDate}&end=${this.TakeawayEndDate}`
        )
        .then((res) => {
          this.TicketsTakeAway = res.data;

          this.typesLoaded = true;
        })
        .catch((err) => {});
    },
  },
  created() {
    this.GetKitchenTickets();
    this.GetKitchenRoomTickets();
    this.GetKitchenTakeawayickets();
  },
};
</script>

<style lang="scss" scoped>
#Home {
  img {
    max-width: 400px;
  }
}
.ProductArea {
  height: 66vh;
  width: 100%;
  overflow-x: scroll;
  margin-top: 8px;
}
.btnType {
  background: #636363 !important;
  color: white;
  width: 46%;
  display: block !important;
}
.btnType:hover {
  background: #383838 !important;
  color: white;
  width: 46%;
}
// .btnTable {
//   background: #636363 !important;
//   color: white;
//   width: 46%;
//   display: block !important;
// }
// .btnTable:hover {
//   background: #383838 !important;
//   color: white;
//   width: 46%;
// }
.tableHead {
  background-color: #589442;
  color: white;
  padding: 3px;
}
.margin-0 {
  margin-right: 0px !important;
  // margin-left:0px !important;
}
.w-100 {
  width: 100% !important;
}
// .orderDetails {
//   width: 300px;
//   position: absolute !important;
// }
.headerBtn {
  color: #353535;
  background-color: white !important;
  width: 46%;
  display: block !important;
}
.headerbtn:hover {
  background-color: white !important;
  color: #ff3008 !important;
  border-color: #ff3008 !important;
}

.Home {
  background-image: url('../assets/img/body-pattern.jpg');
  // background-image: url("../assets/img/body-pattern1.jpg");
  // background-image: url("../assets/img/body-pattern2.jpg");
  // background-image: url("../assets/img/body-pattern3.jpg");
  // background-image: url("../assets/img/body-pattern4.jpg");
}
.downIcon:after {
  content: '\33';
  font-family: 'ElegantIcons';
}
.dropdown-button {
  position: relative;
  z-index: 1;
  padding-right: 11px;
  // border: 1px solid #ededed;
  border: 4px dotted #175600;
  padding: 2px;
  border-radius: 3px;
  height: 49px;
}
.dropdown-text {
  color: #3e3e3e;
  font-size: 14px;
  font-size: 0.93333rem;
  line-height: 1.57143;
  font-weight: 700;
}
.dropdown-selected,
.dropdown-text {
  display: block;
}
.dropdown-selected {
  // display: none;
  overflow: hidden;
  width: 100%;
  color: #a9a9a9;
  font-size: 12px;
  font-size: 0.8rem;
  line-height: 1.1;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.p-7 {
  padding: 7px;
}
.p-0 {
  padding: 0 !important;
}
.pt-8 {
  padding-top: 8px;
}
.pb-8 {
  padding-bottom: 8px;
}
.pl-15 {
  padding-left: 15px !important;
}
.bill {
  background: #f3f3f3;
}
.bill_area {
  padding: 15px;
  padding-top: 10px;
}
.cart {
  width: 100%;
  padding: 14px;
  color: #fff;
  background: linear-gradient(
    90deg,
    var(--brand-primary-dark) 0%,
    var(--brand-primary) 55%,
    var(--brand-primary-light) 100%
  );
  font-size: 17px;
}
.cart:before {
  content: '\e015';
  font-family: 'ElegantIcons';
  margin-right: 13px;
}
.w-280 {
  width: 280px;
}
.secondry-color {
  color: rgb(117, 117, 117) !important;
}
.text-left {
  text-align: left;
}
.basket-area .single-item h5 span {
  font-size: 10px;
  padding-top: 2px;
}

body {
  background: #e0e5ec;
}
h1 {
  position: relative;
  text-align: center;
  color: #353535;
  font-size: 50px;
  font-family: 'Cormorant Garamond', serif;
}

p {
  font-family: 'Lato', sans-serif;
  font-weight: 300;
  text-align: center;
  font-size: 18px;
  color: #676767;
}
.frame {
  width: 90%;
  margin: 40px auto;
  text-align: center;
}

* {
  font-family: 'Work Sans', sans-serif;
}
html,
body {
  height: 100%;
  color: #1a1b1c;
}

label,
a {
  cursor: pointer;
  user-select: none;
  text-decoration: none;
  display: inline-block;
  color: inherit;
  transition: border 0.2s;
  border-bottom: 5px solid rgba(#8e44ad, 0.2);
  padding: 3px 2px;
  &:hover {
    border-bottom-color: #5596d2;
  }
}

.layout {
  display: grid;
  height: 100%;
  height: 700vh;
  width: 100%;
  overflow: hidden;
  grid-template-rows: 50px 1fr;
  grid-template-columns: 1fr 1fr 1fr;
}

.vm--overlay {
  height: 100% !important;
}
input[type='radio'] {
  display: none;
}

label.nav {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-bottom: 2px solid #8e44ad;
  background: #ecf0f1;
  user-select: none;
  transition: background 0.4s, padding-left 0.2s;
  padding-left: 0;
  input[type='radio']:checked + .page + & {
    background: #5596d2;
    color: #ffffff;
    padding-left: 20px;
    span {
      padding-left: 20px;
    }
    svg {
      opacity: 1;
    }
  }
  span {
    padding-left: 0px;
    position: relative;
  }
  svg {
    left: 0;
    top: -3px;
    position: absolute;
    width: 15px;
    opacity: 0;
    transition: opacity 0.2s;
  }
}

.page {
  grid-column-start: 1;
  grid-row-start: 2;
  grid-column-end: span 3;
  padding: 0px 20px;

  align-items: center;
}

.page-contents > * {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.2s, transform 0.2s;
  @for $c from 1 through 20 {
    &:nth-child(#{$c}) {
      transition-delay: 0.2s + ($c * 0.2s);
    }
  }
}

input[type='radio'] + .page {
  transition: transform 0.2s;
  transform: translateX(100%);
}

input[type='radio']:checked + .page {
  transform: translateX(0%);
  .page-contents > * {
    opacity: 1;
    transform: translateY(0px);
  }
}

.page-contents {
  width: 100%;

  margin: 5px;
}
</style>
<style scoped>
.secondtab {
  margin-top: -177px !important;
}
header.header_in {
  padding: 18px 0 39px;
}

.spaceHeight {
  height: 40px;
}
</style>
